<template>
  <div class="ccontainer" v-if="!videoCallRoom.is_unlimited && videoCallRoom.is_receiver && secondsLeft < 30" >
    <div class="prejoin-preview-dropdown-container">
      <div
        aria-label="Start call"
        class="css-1hbmoh1-actionButton tertiary"
        role="button"
        tabindex="0"
        @click="unlimited"
      >
        {{ $t("videocall.button.unlimited") }}
      </div>
    </div>
  </div>
</template>

<script>
import resources from "../../../resources";

export default {
  props: {
    videoCallRoom: {
      required: true,
      default: () => {
        return {};
      },
    },
    secondsLeft: {
      required: true,
    },
  },
  methods: {
    unlimited() {
      resources.videoCallRoom
        .storeAt({ id: this.$route.params.hash + "/unlimited" })
        .then((response) => {
          if (response.status != 200 || response.data.started_at === null) return;
          
          this.videoCallRoom.is_unlimited = response.data.is_unlimited;
        })
        .catch((error) => {
          if (error.status == 422) {
            // Here maybe I should redirect the user. or show an error message.
            console.log("VideoCallRoom does not exist");
            return;
          }
          console.log("error", error);
        });
    },
  },
};
</script>

<style scoped lang="scss">
@import "../jisti.scss";
</style>
